export default __webpack_public_path__ + "static/media/predictor.771e4741.svg";